import { get, compact } from 'lodash-es';
import { EdmundsAPI } from 'client/data/api/api-client';
import { withMetrics } from 'client/data/api/api-metrics';
import { createModelSegment } from 'client/data/luckdragon/segment';
import { VisitorModel } from './visitor';

const DEFAULT_ARRAY = [];
const DEFAULT_VINS = {
  totalNumber: 0,
  results: DEFAULT_ARRAY,
};

function detectYear(modelYear) {
  const NO_VALUE = '';
  const year = get(modelYear, 'year', NO_VALUE);
  return year === 'agnostic' ? NO_VALUE : year;
}

/**
 * Get search results page API Url for conquest module
 * @param {object} params
 * @returns {string}
 */
export function getSimilarVehiclesPageUrl(params) {
  const {
    make,
    model,
    modelYear,
    zipCode,
    latitude,
    longitude,
    dma,
    rooftopId,
    inventoryType,
    pageSize = 5,
    facets = false,
    sortBy,
    stateCode,
    parentDealershipName,
    national,
    bodyType,
    broadSearch,
  } = params;

  if (!broadSearch && (!make || !model)) {
    return null;
  }

  const radius = 100; // Set a hardcoded radius of 100mi to purchase-funnel for the conquest module - BLT-1981
  const year = detectYear(modelYear);

  const queryParams = compact([
    `seoInfo=false`,
    inventoryType && `&inventoryType=${inventoryType}`,
    make && `&make=${make.niceName}`,
    model && `&model=${model.niceName}`,
    year && `&year=${year}`,
    bodyType && `&bodyType=${bodyType.name}`,
    `&pageSize=${pageSize}`,
    `&fetchFacets=${facets}`,
    // if we have not specified a rooftop id, then only show inventory for partner dealers (ie. directDealers) that
    // are nearby
    rooftopId ? `&rooftopId=${rooftopId}` : '&productFeature=directDealer',
    `&radius=${radius}&zip=${zipCode}&lat=${latitude}&lon=${longitude}`,
    dma && `&dma=${dma}`, // we don't always have DMA so we need to check it exists before adding it
    sortBy && `&sortby=${sortBy}`,
    stateCode && `&stateCode=${stateCode}`,
    parentDealershipName && `&parentDealership=${parentDealershipName}`,
    national && `&national=${national}`,
  ]).join('');

  return `/purchasefunnel/v1/srp/inventory?${queryParams}`;
}

export const InventorySimilarVinsModel = createModelSegment('inventorySimilarVins', [
  {
    path: 'filters',
  },
  {
    path: 'vinsV2',
    async resolve(match, context) {
      const [filters, location] = await Promise.all([
        context.resolveValue('filters'),
        context.resolveValue('location', VisitorModel),
      ]);

      const url = getSimilarVehiclesPageUrl({ ...filters, ...location });

      if (!url) {
        return context.abort();
      }

      return withMetrics(EdmundsAPI, context)
        .fetchJson(url)
        .then(data => get(data, 'inventories', DEFAULT_VINS));
    },
  },
]);
